import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AddUpdModal from "./AddUpdModal";
import {
  getUsers,
  deleteUser,
  resourcesConcesionarios,
  activeRoutes,
} from "../../../helpers/backend_helper";
import { DestroyAlertHelper, Alert } from "../../../helpers/alerts/alertHelper";
import { getPolicyUser, getStorageUser } from "../../../helpers/api_helper";
import { Container } from "reactstrap";
import ButtonHelper from "../../../helpers/ButtonHelper";

const Concesionarios = () => {
  const authUser = getStorageUser();
  const [pending, setPending] = useState(false);
  const [modal, setModal] = useState({ show: false, update: false });
  const [modalObserv, setModalObserv] = useState({
    show: false,
    type: 1,
    id: null,
  });
  const [modalFile, setModalFile] = useState({
    show: false,
    id: null,
    files: [],
  });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    companySession: authUser.company_id,
  });
  const [items, setItems] = useState([]);

  const [itemBase, setItemBase] = useState({
    id: null,
    name: "",
    lname1: "",
    lname2: "",
    phone: "",
    local_phone: "",
    route_id: authUser.route_id,
    email: "",
    code: "",
    phone_validated: 0,
  });

  const [item, setItem] = useState(itemBase);
  const dispatch = useDispatch();
  useEffect(() => {
    const getConcesionarios = async () => {
      let params = { params: filters };
      const response = await resourcesConcesionarios("get", params);
      setItems(response.data);
      setDataPag(response.meta);
      setPending(false);
    };
    getConcesionarios();
  }, [filters]);

  const addUpd = (row = false) => {
    setItem(row.id ? row : itemBase);
    setModal({ ...modal, show: true, update: row.id ? true : false });
  };

  const destroy = async (id) => {
    DestroyAlertHelper(async (confirmed) => {
      if (!confirmed) {
        return;
      }
      const response = await resourcesConcesionarios("del", id, id);
      Alert(response.message, response.status);
      if (response.status) {
        setItems(items.filter((i) => i.id != id));
      }
    });
  };

  const columns = Columns(addUpd, destroy);
  document.title = "Concesionarios | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Concesionarios"
              filterInp={true}
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              {authUser.can.operators.create && (
                <div className="mb-3">
                  <ButtonHelper addButon={true} actionAddButon={addUpd} />
                </div>
              )}
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && (
          <AddUpdModal
            modal={modal}
            setModal={setModal}
            items={items}
            setItems={setItems}
            item={item}
            setItem={setItem}
            authUser={authUser}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Concesionarios;
